<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Well Barrier Status Historical Record Detail
    </div>
    <div>
        <button mat-dialog-close>
            <ng-container [ngTemplateOutlet]="closedIcon"></ng-container>
        </button>
    </div>
</div>
<hr class="my-0">

<mat-dialog-content #pageContainer style="padding: 5px;">
    <div class="text-center text-3xl py-6">
        <b>{{ data.wellLongName }}</b>
    </div>

    <table class="table table-zebra text-center table-border-bottom">
        <thead class="header">
            <tr class="text-center tableHeader-bg-color">
                <td> No </td>
                <td> Element </td>
                <td> Status </td>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="historyDetails.length > 0 ; else noData">
                <tr *ngFor="let details of historyDetails; let i = index">
                    <td>{{i + 1 }}</td>
                    <td>{{ details.element }}</td>
                    <td align="center">
                        <div class="w-1/2" [ngClass]="getStatusClass(details.status)">{{ details.status ?? '-' }}</div>
                    </td>
                </tr>
            </ng-container>
        </tbody>

        <ng-template #noData>
            <tr>
                <td style="background-color: #f5f5f5;" colspan="10">No data available</td>
                <td style="background-color: #f5f5f5;" colspan="27"></td>
            </tr>
        </ng-template>
    </table>

</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex justify-between w-full pt-5">
        <div class="flex flex-col justify-center items-start">
            <div>Updated By : {{data.historyRecordDetail.inputBy ?? '-' }}</div>
            <div>Updated Date : {{ handleFormatDate(data.historyRecordDetail.inputDate, false) ?? '-' }} </div>
        </div>
        <button class="btn btn-outline btn-error mx-4" mat-dialog-close>
            Cancel
        </button>
    </div>
</mat-dialog-actions>


<ng-template #closedIcon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
</ng-template>